<h2 class="page-title" mat-dialog-title>Release Phone Number?</h2>
<mat-dialog-content class="mat-dialog-content-no-heading">
  <div class="confirmation-dialog-message">
    @if (phoneExtensionList.length > 0) {
      <div>
        This phone number is currently set as the Default Phone Number for the following Phone extension{{
        phoneExtensionList.length > 1 ? 's' : ''
        }}:
        <ul class="extension-list">
          @for (extension of phoneExtensionList; track extension) {
            <li> {{ extension.number }} - {{ extension.name }} </li>
          }
        </ul>
      </div>
    }
    @if (faxExtensionList.length > 0) {
      <div>
        @if (phoneExtensionList.length > 0) {
          <p>
            And the following Fax extension{{ faxExtensionList.length > 1 ? 's' : '' }}:
          </p>
        }
        @if (phoneExtensionList.length == 0) {
          <p>
            This phone number is currently set as the Default Phone Number for the following fax extension{{
            faxExtensionList.length > 1 ? 's' : ''
            }}:
          </p>
        }
        <ul class="extension-list">
          @for (extension of faxExtensionList; track extension) {
            <li> {{ extension.number }} - {{ extension.name }} </li>
          }
        </ul>
      </div>
    }
    @if (phoneExtensionList.length > 0 || faxExtensionList.length > 0) {
      <div>
        Clicking Yes will reset the Default Phone Number for these extensions, limiting Phones to internal calls and
        disabling any Fax extensions.
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button" mat-raised-button color="primary" (click)="onConfirm()">Yes</button>
  <button type="button" mat-button (click)="onCancel()" mat-dialog-close>No</button>
</mat-dialog-actions>
